enum ValidatorEventEnum {
  DEPOSITS = 'deposits',
  WITHDRAWALS = 'withdrawals',
  CONSOLIDATIONS = 'consolidations',
}
export { ValidatorEventEnum };
